/* tslint:disable */
/* eslint-disable */
/**
 * home-health-api
 * home-health-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { HchbPayorTypePage } from './HchbPayorTypePage';
import {
    HchbPayorTypePageFromJSON,
    HchbPayorTypePageFromJSONTyped,
    HchbPayorTypePageToJSON,
    HchbPayorTypePageToJSONTyped,
} from './HchbPayorTypePage';

/**
 * 
 * @export
 * @interface FindAllHchbPayorTypes200Response
 */
export interface FindAllHchbPayorTypes200Response {
    /**
     * 
     * @type {HchbPayorTypePage}
     * @memberof FindAllHchbPayorTypes200Response
     */
    data?: HchbPayorTypePage;
}

/**
 * Check if a given object implements the FindAllHchbPayorTypes200Response interface.
 */
export function instanceOfFindAllHchbPayorTypes200Response(value: object): value is FindAllHchbPayorTypes200Response {
    return true;
}

export function FindAllHchbPayorTypes200ResponseFromJSON(json: any): FindAllHchbPayorTypes200Response {
    return FindAllHchbPayorTypes200ResponseFromJSONTyped(json, false);
}

export function FindAllHchbPayorTypes200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): FindAllHchbPayorTypes200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'data': json['data'] == null ? undefined : HchbPayorTypePageFromJSON(json['data']),
    };
}

export function FindAllHchbPayorTypes200ResponseToJSON(json: any): FindAllHchbPayorTypes200Response {
    return FindAllHchbPayorTypes200ResponseToJSONTyped(json, false);
}

export function FindAllHchbPayorTypes200ResponseToJSONTyped(value?: FindAllHchbPayorTypes200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': HchbPayorTypePageToJSON(value['data']),
    };
}

